<template>
  <div class="mx-3">
    <b-form @submit="onSubmit" @reset="onReset">
      <h4>Create a comment</h4>
      <b-row>
        <b-col md="6">
          <b-form-group id="input-group-2" label="Date" label-for="date-input">
            <b-form-input
              id="date-input"
              type="date"
              v-model="comment['created_date']"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            id="content-textbox"
            label="Comment"
            label-for="content-input"
          >
            <b-form-textarea
              id="content-input"
              rows="6"
              v-model="comment['content']"
            ></b-form-textarea>
          </b-form-group> </b-col
      ></b-row>
      <b-row v-if="!isOfdit" style="text-align:center">
        <b-col>
          <em>
            Your comment will be automatically emailed to the OFDIT lead
          </em>
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-button class="mx-3" type="reset" variant="secondary"
          >Cancel</b-button
        >
        <b-button class="mx-3" type="submit" variant="primary">Submit</b-button>
      </b-row>
    </b-form>
  </div>
</template>

<script>
  export default {
    name: 'GCommentForm',
    created: function() {
      this.getTodaysDate()
    },
    data() {
      return {
        comment: {
          created_date: '',
          content: ''
        }
      }
    },
    methods: {
      getTodaysDate() {
        let x = new Date()
        this.comment.created_date = x.toISOString().substring(0, 10)
      },
      onSubmit(evt) {
        evt.preventDefault()
        this.comment['author_id'] = this.currentUser['id']
        this.comment['author_name'] = this.currentUser.full_name
        this.comment['project_id'] = this.currentProject['id']
        this.comment['course'] = this.currentProject.course
        this.$store
          .dispatch('createComment', this.comment)
          .then(() => {
            this.$bvToast.toast(
              `${this.$store.state.courseDev.ui.toastMessage}`,
              {
                title: 'Success',
                autoHideDelay: 1000,
                toaster: 'b-toaster-top-center',
                variant: 'success'
              }
            )
          })
          .catch(err => {
            console.error(err)
          })
        if (!this.isOfdit) {
          this.comment['ofdit_lead'] = this.currentProject.ofdit_lead
          this.comment[
            'ofdit_lead_email'
          ] = this.currentProject.ofdit_lead_email
          this.$store
            .dispatch('email', this.comment)
            .then(() => {
              this.$bvToast.toast(
                `Your comment has been emailed to
            ${this.currentProject.ofdit_lead}`,
                {
                  title: 'Success',
                  autoHideDelay: 1000,
                  toaster: 'b-toaster-top-center',
                  variant: 'success'
                }
              )
            })
            .catch(err => {
              console.error(err)
            })
        }
        this.$store.dispatch('toggleCommentForm')
        this.comment = {
          created_date: '',
          content: ''
        }
      },
      onReset(evt) {
        evt.preventDefault()
        this.comment.content = ''
        this.$store.dispatch('toggleCommentForm')
      }
    },
    computed: {
      isOfdit() {
        return this.$store.getters.isOfdit
      },
      currentProject() {
        return this.$store.getters.currentProject
      },
      currentUser() {
        return this.$store.getters.currentUser
      }
    }
  }
</script>
